import { lazy } from "react";

const AuthRoutes: any[] = [
  {
    id: "signup",
    name: "Signup",
    path: "/signup",
    component: lazy(() => import("@/pages/user/auth/signup")),
    type: "open",
    props: {},
  },
  {
    id: "signin",
    name: "Signin",
    path: "/signin",
    component: lazy(() => import("@/pages/user/auth/signin")),
    type: "open",
    props: {},
  },
  {
    id: "resetPassword",
    name: "Reset Password",
    path: "/reset-password",
    component: lazy(() => import("@/pages/user/auth/reset-pass")),
    type: "open",
    props: {},
  },
];

export default AuthRoutes;
